var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "container mb-5 pages-inner-container",
        attrs: { id: "main-container" }
      },
      [
        _c("div", { staticClass: "row justify-content-center" }, [
          _c("div", { staticClass: "my-5 content-page-container col-12" }, [
            _c("div", { staticClass: "main-panel mt-0 px-0 mb-0 pb-2 py-4" }, [
              _c("div", { staticClass: "back-button-container row px-3" }, [
                _c(
                  "button",
                  {
                    staticClass: "px-0",
                    on: { click: _vm.redirectToDefaultBrowse }
                  },
                  [
                    _c("font-awesome-icon", {
                      attrs: { icon: ["fas", "arrow-left"] }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "pl-1" }, [
                      _vm._v(_vm._s(_vm.contentPageNavigationText))
                    ])
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "title-container row pt-4 px-3" }, [
                _c(
                  "h1",
                  [
                    _vm._v(_vm._s(_vm.contentPageModel.title)),
                    _c("employee-hub-bookmark", {
                      attrs: { title: _vm.contentPageModel.title }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", {
                staticClass:
                  "d-flex flex-lg-row flex-column mt-2 px-2 py-1 mb-2"
              }),
              _vm._v(" "),
              _c("div", { staticClass: "row pt-3" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("div", { staticClass: "rel-container" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "row preview-panel content-pages-panel px-3"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "col-12" },
                          [
                            _vm.contentPageModel.id
                              ? _c("froalaView", {
                                  model: {
                                    value: _vm.contentPageModel.content,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.contentPageModel,
                                        "content",
                                        $$v
                                      )
                                    },
                                    expression: "contentPageModel.content"
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    )
                  ])
                ])
              ])
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cd9fc97a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cd9fc97a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ViewContentPage.vue
// module id = null
// module chunks = 